import { combineReducers } from 'redux';
import signIn from './signIn';
import orgSelection from './orgSelection';
import newPassword from './newPassword';
import changePassword from './changePassword';
import auth from './auth';
import viewDemo from './viewDemo';

const routeReducer = combineReducers({
  auth,
  signIn,
  orgSelection,
  newPassword,
  changePassword,
  viewDemo,
});

export default routeReducer;



// WEBPACK FOOTER //
// ./src/reducers/routeReducers/index.js